import { createSlice } from "@reduxjs/toolkit";
import { deleteBrand, getBrandById, getBrandList, updateBrand } from "./ThunkActions";
import { iBrandState, REDUCER_NAME } from "./Types";

const initialState: iBrandState = {
  isLoading: false,
  brand: null,
  errorMessage: null,
  brandList: [],
};

export const brandsSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetBrandState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getBrandById.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = null;
    })
    .addCase(getBrandById.fulfilled, (state, action) => {
      state.isLoading = false;
      if (action.payload?.data?.data) {
        state.brand = action.payload.data.data;
      }
    })
    .addCase(getBrandById.rejected, (state, action) => {
      state.isLoading = false;
      //@ts-ignore

      state.errorMessage = action.payload?.message || "Failed to fetch brand data";
    })
      .addCase(getBrandList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBrandList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.brandList = payload.data;
          state.isLoading = false;
        }
      })
      .addCase(getBrandList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch brand data";
        state.isLoading = false;
      })
      .addCase(updateBrand.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(updateBrand.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload?.data?.data) {
          // Update the brand in state if needed
          state.brand = action.payload.data.data;
          // Update the brand in the list if it exists
          const updatedBrand = action.payload.data.data;
          state.brandList = state.brandList.map(brand => 
            brand.id === updatedBrand.id ? updatedBrand : brand
          );
        }
      })
      .addCase(updateBrand.rejected, (state, action) => {
        state.isLoading = false;
      //@ts-ignore

        state.errorMessage = action.payload?.message || "Failed to update brand";
      })
      .addCase(deleteBrand.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(deleteBrand.fulfilled, (state, action) => {
        state.isLoading = false;
        const brandId = action.meta.arg.brandId;
        state.brandList = state.brandList.filter(brand => brand.id !== brandId);
      })
      .addCase(deleteBrand.rejected, (state, action) => {
        state.isLoading = false;
      //@ts-ignore

        state.errorMessage = action.payload?.message || "Failed to delete brand";
      });
  },
});

export const { resetBrandState } = brandsSlice.actions;
export default brandsSlice.reducer;